import classNames from 'classnames'
import { DateTime } from 'luxon'
import { CROSSCHAIN_CONFIG, OMNIPOOL_CONFIG } from '~/lib/config'
import Typography from '~/components/Typography'
import { OmniPoolWithReward } from '../types'
import { getFormattedSISValue } from '../utils'
import FarmInfo from './FarmInfo'
import styles from './FarmDetails.pcss'
import Tokens from './Tokens'

import CrossIcon from '~/assets/icons/cross.svg'
import LinkIcon from './assets/link.svg'
import { hasProjectTokens } from '~/lib/helpers'
import { IconButton } from '~/components/IconButton'
import { useGetOriginLikeToken } from '~/hooks/useGetOriginLikeToken'

interface Props {
	className?: string
	data: OmniPoolWithReward
	onClose: () => void
}

function getFormattedDate(timestamp?: number): string {
	if (!timestamp) {
		return '-'
	}

	return DateTime.fromSeconds(timestamp).toFormat('MM/dd/yyyy HH:mm')
}

function FarmDetails({ className, data, onClose }: Props) {
	const { token } = data.pool

	const name = token.name.replace('Synthetic ', '')

	return (
		<div className={classNames(styles.container, className)}>
			<div className={styles.about}>
				<Typography className={styles.title} tag="div" size="XL">
					About {name}
				</Typography>
				<IconButton
					className={styles.crossButton}
					icon={CrossIcon}
					onClick={() => {
						onClose()
					}}
				/>
			</div>

			<Tokens className={styles.tokens} token={token} />

			<div className={styles.content}>
				<FarmInfo className={styles.info} title="Week:">
					{data.reward?.week.week || '-'}
				</FarmInfo>

				<FarmInfo className={styles.info} title="Week rewards:">
					{getFormattedSISValue(data.reward?.week.reward.toString())}
				</FarmInfo>

				<FarmInfo className={styles.info} title="Unlocked:">
					{getFormattedSISValue(
						data.reward?.week.availableToClaim.toString()
					)}
				</FarmInfo>

				<FarmInfo className={styles.info} title="Rewards vested:">
					{getFormattedSISValue(
						data.reward?.week.rewardsVested.toString()
					)}
				</FarmInfo>

				<FarmInfo className={styles.info} title="Vesting end at:">
					{getFormattedDate(data.reward?.week.vestingEndAt)}
				</FarmInfo>

				<div className={styles.divider} />

				<FarmInfo className={styles.info} title="Pool rewards:">
					{getFormattedSISValue(data.reward?.reward.toString())}
				</FarmInfo>

				<FarmInfo className={styles.info} title="Available to claim:">
					{getFormattedSISValue(
						data.reward?.availableToClaim.toString()
					)}
				</FarmInfo>

				<FarmInfo className={styles.info} title="Rewards vested:">
					{getFormattedSISValue(
						data.reward?.rewardsVested.toString()
					)}
				</FarmInfo>
			</div>

			<a
				className={styles.link}
				target="_blank"
				rel="noreferrer"
				href={`${OMNIPOOL_CONFIG.webApp}/liquidity-v2/add-stable?token=${token.address}&chain=${token.chain.name}`}
			>
				<Typography>CHECK POOL</Typography>
				<LinkIcon className={styles.linkIcon} />
			</a>
		</div>
	)
}

export default FarmDetails
